<mat-card>
  <mat-card-title> Create Flight Log </mat-card-title>
  <mat-divider></mat-divider>
  <ng-template
    flLoading
    [flLoadingUntil]="flightLog$ | async"
    flLoadingStrategy="overlay"
    flLoadingColor="primary"
  >
    <div *ngIf="flightLog$ | async as flightLog">
      <fl-flight-log-form *ngIf="flightLog" [flightLog]="flightLog"></fl-flight-log-form>
    </div>
  </ng-template>
</mat-card>
